import "./PasswordChecklist.css";

import React, { useEffect, useState } from "react";

import greenTick from "../../../assets/imgs/green-tick.svg";
import redEx from "../../../assets/imgs/red-x.svg";

const ReactPasswordChecklist = React.lazy(
  () => import("react-password-checklist"),
);

const PasswordChecklist = ({ password }: { password: string }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <React.Suspense fallback={null}>
      <div className="PasswordChecklist">
        <ReactPasswordChecklist
          className="PasswordChecklist__component"
          rules={["minLength", "number", "capital", "lowercase"]}
          minLength={8}
          value={password}
          iconComponents={{
            ValidIcon: <img src={greenTick.src} alt="Valid icon" />,
            InvalidIcon: !password.length ? (
              <span className="PasswordChecklist__spacer" />
            ) : (
              <img src={redEx.src} alt="Invalid icon" />
            ),
          }}
          messages={{
            minLength: "Password has 8 or more characters.",
            capital: "Password has an uppercase letter.",
          }}
        />
      </div>
    </React.Suspense>
  );
};

export default PasswordChecklist;
